<template>
  <div v-if="customerId && !customerIsSignedUpForSmsMarketing" class="pos-rel d-flex-100 align-content-start viber-form" id="userViber" :class="extraWrapperClass">
    <div class="viber-form-head">
      <p class="viber-form-head-title">{{ t('viber.form.title') }}</p>
    </div>
    <div class="viber-form-body">
      <p class="viber-form-body-text">{{ t('viber.form.text') }}</p>
      <div class="d-flex-100 viber-form-body-form" id="submitViber">
        <input class="viber-form-body-form-input" :placeholder="placeholderText" type="text" v-model="phone">
        <button
          class="viber-form-body-form-button"
          v-on:click="formSubmit()"
          type="button"
          :aria-label="t('entry.lbl')"
        >
          <span v-show="!isLoading">{{ t('entry.lbl') }}</span>
          <span v-if="isLoading" class="loader"></span>
        </button>
      </div>
    </div>
    <div class="viber-form-footer">
      <div class="viber-form-footer-checkbox">
        <input
          id="viberCheckBox"
          type="checkbox"
          class="viber-form-footer-checkbox-input"
          name="viberCheckBox"
          :checked="addToViberChecked"
          disabled
        >
        <label for="viberCheckBox" class="viber-form-footer-checkbox-label">
          <span class="viber-form-footer-checkbox-label-text">
            {{ t('viber.checkbox.agree.label') }}
          </span>
        </label>
      </div>
      <div v-if="showError && error" class="viber-form-footer-error alert alert-error">{{ error }}</div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ViberForm',
  props: {
    extraWrapperClass: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    customerId: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      formPosted: false,
      showError: false,
      error: '',
      phone: '',
      addToViberChecked: true,
      placeholderText: this.t('viber.phone.placeholder'),
      customerIsSignedUpForSmsMarketing: true,
      isLoading: false
    }
  },
  async created () {
    if (this.placeholder) {
      this.placeholderText = this.placeholder
    }
    await axios
      .get('/api/customer/getCustomerIsSignedUpViber')
      .then((response) => {
        this.customerIsSignedUpForSmsMarketing = response.data.isSignedUpViber
      })
      .catch(() => {
        this.customerIsSignedUpForSmsMarketing = true
      })
  },
  methods: {
    formSubmit () {
      if (!this.validatePhone()) {
        this.error = this.t('viber.phone.error')
        this.showError = true
        return
      }

      this.postData()
    },
    validatePhone () {
      const phone = this.phone.replace(/[-+\s]/g, '')

      if (phone.length < 10) {
        return false
      }

      if (phone.indexOf('3069') === 0 && phone.length === 12) {
        return true
      }

      if (phone.indexOf('003069') === 0 && phone.length === 14) {
        return true
      }

      return phone.indexOf('69') === 0 && phone.length === 10
    },
    postData () {
      this.isLoading = true
      axios
        .post('/api/customer/setViberPhone', {
          addToViber: true,
          phone: this.phone
        })
        .then((response) => {
          const responseMessage = response.data.detail
          this.$toasted.success(responseMessage)
          this.formPosted = true
          this.customerIsSignedUpForSmsMarketing = true
        })
        .catch((error) => {
          if (error.response) {
            this.error = error.response.data.phone
            this.showError = true
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.fade-enter, .fade-leave-to { opacity: 0 }
.fade-leave, .fade-enter-to { opacity: 1 }
.fade-enter-active, .fade-leave-active { transition: opacity 1000ms }

.loader {
  position: relative;
  display: grid;
  border: 6px solid #f3f3f3;
  border-radius: 50%;
  border-top: 6px solid #3498db;
  width: 26px;
  height: 26px;
  animation: spin 2s linear infinite;
  justify-items: center;
  align-items: center;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.viber-form {
  background-color:#9368B7;
  color:#fff;
  padding:30px;
  height:100%;
  @media (max-width:767px), (min-width:992px) and (max-width:1199px){
    padding:15px
  }
  input[type="text"]{
    height:48px;
    margin-right:15px;
    flex:0 0 60%;
    max-width:60%
  }
  button{
    height:48px;
    background: #000;
    border:0;
    color:#fff;
    padding:0 10px;
    flex:0 0 35%;
    max-width: 35%;
    margin-left:auto
  }
  @media screen and (max-width:767px){
    input[type="text"]{
      flex:0 0 calc(60% - 15px);
      max-width: calc(60% - 15px)
    }
    button{
      flex:0 0 38%;
      max-width: 38%;
      font-size: 15px;
      margin-left:auto
    }
  }
  @media screen and (max-width:500px){
    margin-top:15px;
    margin-bottom: 15px
  }
  @media (max-width:400px), (min-width:992px) and (max-width:1199px){
    input[type="text"]{
      flex:0 0 53%;
      max-width: 53%;
      margin-right:0
    }
    button{
      flex:0 0 47%;
      max-width: 47%;
      font-size:14px
    }
  }
}
.viber-form-head-title{
  font-size: 39px;
  font-weight: 900;
  line-height: 1.3;
  @media screen and (min-width:768px) and (max-width:991px){
    font-size: 27px
  }
  @media (max-width:767px), (min-width:992px) and (max-width:1199px){
    font-size: 17px;
    font-weight: 800
  }
}
.viber-form-body-text{
  line-height: 1.3;
  @media screen and (min-width:992px) and (max-width:1199px){
    font-size: 14px
  }
}

.viber-form-footer-checkbox{
  label{
    @media (max-width:500px), (min-width:992px) and (max-width:1199px){
      font-size:13px
    }
  }
}

.viber-form-footer-checkbox-label-text{
  @media screen and (max-width:400px){
    font-size: 12px
  }
}
</style>
